import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import * as signalR from '@microsoft/signalr';

@Component({
  selector: 'app-notification-test',
  templateUrl: './notification-test.component.html',
  styleUrls: ['./notification-test.component.css']
})
export class NotificationTestComponent implements OnInit, OnDestroy {

  public baseUrl: string = environment.baseUrl;
  private hubConnection!: signalR.HubConnection;
  public messages: string[] = [];
  public currentUser: any

  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.startSignalRConnection();
  }

  ngOnDestroy(): void {
    if (this.hubConnection) {
      this.hubConnection.stop();
    }
  }

  private startSignalRConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.baseUrl + "notificationHub", {
        accessTokenFactory: () => this.currentUser.token || ""  // if using JWT
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection.on("ReceiveNotification", (notif) => {
      console.log("Single notification received:", notif);
      this.messages.push("Single: " + notif.message);
    });

    this.hubConnection.on("ReceiveNotificationBulk", (payload) => {
      console.log("Bulk notification received:", payload);
      this.messages.push(`Bulk: ${payload.message} (to ${payload.count} users)`);
    });

    this.hubConnection.start()
      .then(() => console.log("✅ SignalR connected. Waiting for notifications..."))
      .catch(err => console.error("❌ SignalR connection error:", err));
  }
}
